import {ReportRowKind, type PeriodicViewRow} from "../../types";
import {
    IMBALANCED_BALANCE_CHECK_ROW,
    IMBALANCED_BALANCE_CHECK_STICKY_CELL,
} from "../StatementTable/tableStyles.ts";

type KindedRow = {kind: ReportRowKind};

export const COL_SEP_L = "border-l border-l-gray-300";
export const COL_SEP_R = "border-r border-r-gray-300";

export const COLOR_POSITIVE = "text-green-600";
export const COLOR_NEGATIVE = "text-red-600";

export const STICKY_COLUMN_WIDTH = 280;
export const MONTH_COLUMN_WIDTH = 104;
export const SUMMARY_COLUMN_WIDTH = 120;

export function signColorClass(cents: number): string {
    if (cents > 0) return COLOR_POSITIVE;
    if (cents < 0) return COLOR_NEGATIVE;
    return "text-gray-400";
}

export function isDrillableAccount(row: PeriodicViewRow): boolean {
    return row.kind === ReportRowKind.Account && row.lines.length > 0;
}

export function hasLinesInPeriod(row: PeriodicViewRow, periodIndex: number): boolean {
    return row.lines.some((entry) => entry.period_index === periodIndex);
}

export function levelPadding(level: number): string {
    if (level <= 1) return "pl-3";
    if (level === 2) return "pl-8";
    return "pl-12";
}

export function rowClassName(row: KindedRow, isImbalanced: boolean = false): string {
    if (isImbalanced) return IMBALANCED_BALANCE_CHECK_ROW;
    switch (row.kind) {
        case ReportRowKind.Group:
            return "bg-white font-semibold text-gray-900 [&>*]:border-b [&>*]:border-b-gray-100";
        case ReportRowKind.Subtotal:
            return "bg-gray-50 font-semibold text-gray-800 [&>*]:[border-bottom:1px_dashed_#d1d5db]";
        case ReportRowKind.Kpi:
            return "bg-[#F4FAFE] font-bold text-gray-900 hover:bg-[#EAF5FD] [&>*]:[border-top:1px_solid_#d1d5db] [&>*]:[border-bottom:1px_solid_#d1d5db]";
        case ReportRowKind.Account:
            return "bg-white hover:bg-gray-50 text-gray-700 [&>*]:border-b [&>*]:border-b-gray-100";
        case ReportRowKind.BalanceCheck:
            return "bg-[#F4FAFE] font-bold text-gray-900 [&>*]:[border-top:1px_solid_#d1d5db] [&>*]:[border-bottom:1px_solid_#d1d5db]";
        default: {
            const _exhaustive: never = row.kind;
            return _exhaustive;
        }
    }
}

export function stickyCellBg(row: KindedRow, isImbalanced: boolean = false): string {
    if (isImbalanced) return IMBALANCED_BALANCE_CHECK_STICKY_CELL;
    switch (row.kind) {
        case ReportRowKind.Group:
            return "bg-white";
        case ReportRowKind.Subtotal:
            return "bg-gray-50";
        case ReportRowKind.Kpi:
            return "bg-[#F4FAFE] group-hover:bg-[#EAF5FD]";
        case ReportRowKind.Account:
            return "bg-white group-hover:bg-gray-50";
        case ReportRowKind.BalanceCheck:
            return "bg-[#F4FAFE]";
        default: {
            const _exhaustive: never = row.kind;
            return _exhaustive;
        }
    }
}
